<template>
  <Navbar regloginpass logourl="/rental" />

  <section id="resetPassword">
    <div class="container pt-5" data-aos="fade-up">
      <div class="section-caption">
        <h2>Zapomniałeś hasła? Nic się nie stało</h2>
      </div>
      <div class="tile">
        <div class="section-content">
          <div class="row gy-4">
            <div class="mx-auto" style="width: 98%">
              <Alert
                alert-type="alert-info"
                alert-text="Nawet jeśli zapomniałeś hasła do swojego konta, możesz uzyskać dostęp do swoich danych.
                  Wystarczy że podasz nazwę użytkownika i adres email podany przy rejestracji.
                  Na Twoją skrzynkę poczty elektronicznej zostanie wysłana wiadomość z loginem i tymczasowym hasłem, które następnie możesz użyć podczas logowania do konta."
              />
              <div class="input-group mb-3">
                <input
                  type="text"
                  v-model.trim="user"
                  name="username"
                  autocomplete="username"
                  class="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  placeholder="Nazwa użytkownika"
                  required
                />
              </div>
              <div class="input-group mb-3">
                <input
                  type="text"
                  v-model.trim="email"
                  name="email"
                  autocomplete="email"
                  class="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  placeholder="Email"
                  required
                />
              </div>
            </div>
          </div>
          <Alert
            v-if="dataInvalidInfo"
            :key="alertKey"
            alert-type="alert-danger"
            alert-text="Wprowadzono nieprawidłowe dane"
            class="m-1"
          />
          <Alert
            v-if="emailSendingFailedInfo"
            :key="alertKey"
            alert-type="alert-danger"
            alert-text="Wysłanie maila nie powiodło się. Skontaktuj się z pomocą techniczną."
            class="m-1"
          />
          <div class="text-center">
            <button
              type="button"
              id="logButton"
              class="btn-standard m-2"
              @click="onBackButtonClick"
            >
              Wstecz
            </button>
            <button
              type="button"
              id="logButton"
              class="btn-standard m-2"
              @click="onSendButtonClick($event)"
            >
              Wyślij
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Stopka -->
  <Footer />
</template>

<script>
import Alert from "@/components/Alert.vue";
import { RequestResult } from "@/utils/requestResult";
import { makeRequest, scrollToTop } from "@/utils/helpers";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "ResetPasswordView",

  components: {
    Navbar,
    Footer,
    Alert,
  },

  data() {
    return {
      user: null,
      email: null,

      dataInvalidInfo: false,
      emailSendingFailedInfo: false,

      alertKey: 0,
    };
  },

  mounted() {
    scrollToTop();
  },

  methods: {
    async onSendButtonClick(event) {
      this.dataInvalidInfo = false;
      this.emailSendingFailedInfo = false;

      let dataValid =
        this.user !== null &&
        this.user !== "" &&
        this.email !== null &&
        this.email !== "";

      if (dataValid) {
        event.preventDefault();

        let data = {
          action: this.request.ResetUserPassword,
          usr: this.user,
          email: this.email,
        };

        let resetPasswordRequestResponse = await makeRequest(data);

        switch (resetPasswordRequestResponse.data.error) {
          case RequestResult.OK: {
            this.$router.push(this.routePath.ResetPasswordComplete);
            break;
          }
          case RequestResult.InvalidLoginData: {
            this.dataInvalidInfo = true;
            break;
          }
          case RequestResult.GeneralError: {
            this.emailSendingFailedInfo = true;
            break;
          }
        }
      } else {
        this.dataInvalidInfo = true;
      }

      this.alertKey += 1;
    },

    onBackButtonClick() {
      this.$router.push(this.routePath.Login);
    },
  },
};
</script>

<style scoped></style>
